__turbopack_context__.v({
  "accordion": "accordion-module-scss-module__rjv2lq__accordion",
  "accordionContent": "accordion-module-scss-module__rjv2lq__accordionContent",
  "accordionHeader": "accordion-module-scss-module__rjv2lq__accordionHeader",
  "icon": "accordion-module-scss-module__rjv2lq__icon",
});
